import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import SitePage, { CallToAction, styles, T, ACCENT } from '../components/site/SitePage';
import { blogPosts } from '../data/blogPosts';

const date = (d) => new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

// Outils et guides affichés avant les études de cas.
const GUIDES = [
  { to: '/outils/calcul-stock-de-securite', type: 'Outil gratuit', titre: 'Calculateur de stock de sécurité et de point de commande', texte: 'Vos ventes Amazon, Shopify et B2B, votre délai fournisseur : combien garder en réserve et quand repasser commande. Avec le modèle Excel.', visuel: 'SS = z × √(L × σ² + d² × σL²)' },
  { to: '/outils/calcul-marge-amazon', type: 'Outil gratuit', titre: 'Calculateur de marge Amazon, Shopify et B2B', texte: 'Ce que vous rapporte vraiment une vente sur chaque canal, une fois la commission, la logistique, les remises, les retours et la publicité payés.', visuel: 'Marge = prix HT − produit − frais − pub' },
  { to: '/alternative-stocky', type: 'Guide', titre: 'Alternative à Stocky : par quoi remplacer l’outil de stock de Shopify', texte: 'Shopify a fermé Stocky le 31 août 2026. Les options, et laquelle choisir si vous vendez aussi sur Amazon.', visuel: 'Stocky · fermé le 31/08/2026' }
];

const BlogPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SitePage>
      <SEO
        title="Blog : études de cas et outils gratuits"
        description="Études de cas et outils gratuits pour sortir des Excel : bases de données, outils sur mesure et IA pour les équipes e-commerce."
        path="/blog"
        breadcrumb={[['Blog', '/blog']]}
      />
      <section style={{ borderBottom: `1px solid ${T.line}`, background: '#FFFFFF' }}>
        <div style={{ ...styles.container, padding: '64px 24px 48px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <p style={styles.kicker}>Blog</p>
          <h1 style={styles.h1}>Études de cas et outils gratuits</h1>
          <p style={{ ...styles.lead, maxWidth: 640 }}>Sortir des Excel, structurer ses données, automatiser ce qui peut l'être.</p>
        </div>
      </section>

      <section style={{ ...styles.container, paddingTop: 48, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(340px, 100%), 1fr))', gap: 20 }}>
        {GUIDES.map((g) => (
          <Link key={g.to} to={g.to} className="lift" style={{ display: 'flex', flexDirection: 'column', background: '#FFFFFF', border: `1px solid ${T.line2}`, borderRadius: 10, overflow: 'hidden', color: T.ink, textDecoration: 'none' }}>
            <div aria-hidden="true" style={{ aspectRatio: '16 / 9', background: ACCENT, color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: T.mono, fontSize: 'clamp(15px, 1.6vw, 18px)', textAlign: 'center' }}>{g.visuel}</div>
            <div style={{ padding: '18px 20px 20px', display: 'flex', flexDirection: 'column', gap: 10, flex: 1 }}>
              <span style={{ alignSelf: 'flex-start', padding: '2px 8px', border: `1px solid ${ACCENT}`, color: ACCENT, borderRadius: 3, fontFamily: T.mono, fontSize: 12 }}>{g.type}</span>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, fontStretch: '85%', lineHeight: 1.15 }}>{g.titre}</h2>
              <p style={{ margin: 0, fontSize: 15, color: T.muted, flex: 1 }}>{g.texte}</p>
            </div>
          </Link>
        ))}
        {blogPosts.map((post) => (
          <Link key={post.id} to={`/blog/${post.id}`} className="lift" style={{ display: 'flex', flexDirection: 'column', background: '#FFFFFF', border: `1px solid ${T.line2}`, borderRadius: 10, overflow: 'hidden', color: T.ink, textDecoration: 'none' }}>
            <img src={post.image} alt="" loading="lazy" width="800" height="450" style={{ height: 'auto',  width: '100%', aspectRatio: '16 / 9', objectFit: 'cover', display: 'block', background: T.line }} />
            <div style={{ padding: '18px 20px 20px', display: 'flex', flexDirection: 'column', gap: 10, flex: 1 }}>
              <span style={{ alignSelf: 'flex-start', padding: '2px 8px', border: `1px solid ${ACCENT}`, color: ACCENT, borderRadius: 3, fontFamily: T.mono, fontSize: 12 }}>{post.category}</span>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, fontStretch: '85%', lineHeight: 1.15 }}>{post.title}</h2>
              <p style={{ margin: 0, fontSize: 15, color: T.muted, flex: 1 }}>{post.excerpt}</p>
              <p style={{ margin: 0, fontFamily: T.mono, fontSize: 12, color: T.faint }}>{date(post.date)} · {post.readTime}</p>
            </div>
          </Link>
        ))}
      </section>

      <CallToAction from="blog" />
    </SitePage>
  );
};

export default BlogPage;
